import { OAuthError, postData } from "../backend";
import { useModal } from "../contexts";
import { BLOCK_ICON_MAP, BLOCK_NAME_MAP } from "../utils";
import OAuthModalMicrosoft from "./OAuthModalMicrosoft";
import ErrorModal from "./ErrorModal";
import MicrosoftPopupModal from "./MicrosoftPopupModal";
import { MicrosoftOneDrivePickerResponse } from "../interfaces";
import ESignatureLabel from "./ESginatureLabel";
import { BeakerIcon } from "@heroicons/react/outline";
import MicrosoftPickerModal from "./MicrosoftPickerModal";

interface Props {
  blockType: string;
  title: string;
  subtitle: string;
  onSelection: (blockType: string, fileId: string) => void;
  allowedFileTypes: string;
  isComingSoon?: boolean;
  isSignable?: boolean;
}

function WorkflowSelectMicrosoftButton(props: Props) {
  const { openModal, closeModal } = useModal();

  async function handleOpenPicker(basic = false) {
    try {
      await postData("/microsoft/access-token/");

      if (basic)
        return openModal(<MicrosoftPickerModal onSelect={(fileId: string) => props.onSelection(props.blockType, fileId)} />);

      openModal(<MicrosoftPopupModal />);

      const options = {
        clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID,
        action: "query",
        accountSwitchEnabled: false,
        advanced: {
          filter: props.allowedFileTypes,
          redirectUri: window.location.origin
        },
        success: (response: MicrosoftOneDrivePickerResponse) => {
          closeModal();
          props.onSelection(props.blockType, response.value[0].id);
        },
        cancel: closeModal,
        error: (error: Error) => openModal(<ErrorModal details={error} />)
      }

      // @ts-ignore
      OneDrive.open(options);

    } catch (error) {
      if (error instanceof OAuthError)
        openModal(<OAuthModalMicrosoft oauthUrl={error.oauthUrl} onClose={handleOpenPicker} />);
      else
        openModal(<ErrorModal details={error} />);
    }
  }

  return (
    <button className={`relative flex flex-shrink-0 items-center border-2 border-gray-200 rounded px-8 py-4 ${props.isComingSoon ? "bg-gray-50 cursor-not-allowed" : "bg-white cursor-pointer hover:border-blue"} group`} onClick={() => handleOpenPicker()} disabled={props.isComingSoon}>
      <img className="w-12 h-12" src={BLOCK_ICON_MAP[props.blockType]} alt={BLOCK_NAME_MAP[props.blockType]} />
      <div className="flex flex-col items-start ml-4">
        <div className="font-gilroy font-semibold text-lg text-gray-600">
          {props.title}
        </div>
        <div className="font-gilroy font-semibold text-sm text-gray-400">
          {props.subtitle}
        </div>
      </div>
      {props.isComingSoon &&
        <div className="absolute -top-1 -right-2 bg-white shadow rounded border text-xs font-semibold px-2 py-1">
          <span className="text-gray-500">Coming Soon</span>
        </div>
      }
      {props.isSignable &&
        <ESignatureLabel />
      }
      <BeakerIcon className="invisible group-hover:visible w-6 h-6 text-gray-600 hover:text-blue ml-auto border rounded p-1" onClick={(e) => { e.stopPropagation(); handleOpenPicker(true); }} />
    </button>
  );
}

export default WorkflowSelectMicrosoftButton;
